import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const fetchClinicHighlightedSurgeries = (clinicId) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/clinics/highlighted_surgeries`,
    queryParams: [
      {
        name: 'clinic_id',
        value: clinicId,
      },
    ],
  });
};

export default fetchClinicHighlightedSurgeries;
